import UserApiService from './service';
import ApiClientFactory from '../../api/client-factory';

const service = new UserApiService(ApiClientFactory());

export default function UserApiServiceFactory() {
  return service;
}
